var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.TopBar),_c('div',{staticClass:"main-inner main-inner--scroll"},[_c(_setup.FoldersList),_c(_setup.TrackersList,{attrs:{"user-can-add-tracker":_setup.userCanAddTracker}})],1),(_setup.store.getters.isEnterprise)?_c(_setup.Helper,{attrs:{"page":"trackers"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }